// extracted by mini-css-extract-plugin
export default {"seoBlockContent":"c-a_fC","seoBlockContent_visible":"c-a_fE"};